import React, { useContext } from "react";
import NavButton from "../../components/NavButton/index";
import MsmContext, { Actions } from "../../reducers/Context";
import FormInput from "../../components/FormInputs/FormInput";
import ContentHeader from "../../components/ContentHeader/index";
import useForm, { FormContext } from "react-hook-form";

const TeamEntry = () => {
  const { dispatch, state } = useContext(MsmContext);
  const hookForm = useForm({
    defaultValues: {
      teamName:
        state.team && state.team.TeamName
          ? state.team.TeamName
          : state.teamSearchTerm || ""
    }
  });

  const onSubmit = _data => {
    //console.log("dispatch", _data);
    dispatch({
      type: Actions.ADDED_TEAM,
      payload: { teamName: _data.teamName }
    });
  };

  return (
    <>
      <ContentHeader
        text="What is your team called?"
        icon="whitesoccer"
        iconFill="teal"
        iconSize="25"
      />
      <div className="afs-msm-stage-content">
        <FormContext {...hookForm}>
          <form
            onSubmit={e => {
              e.preventDefault();
              hookForm.handleSubmit(onSubmit);
            }}
          >
            <div className="afs-msm-input-holder add-all-padding">
              <FormInput
                name="teamName"
                type="text"
                label="Enter your teams full name"
                helper="If you need to add more teams you can easily do this later"
                placeholder="Minimum 3 characters"
                errorText="You must specify a team name of at least 3 characters"
                validation={{ required: true, minLength: 3 }}
              />
            </div>
          </form>
        </FormContext>
      </div>
      <div className="afs-msm-stage-action-buttons">
        <NavButton text="BACK" actionType={Actions.PREV_STAGE} />
        <NavButton
          text="CONTINUE"
          type="submit"
          onClick={hookForm.handleSubmit(onSubmit)}
        />
      </div>
    </>
  );
};

export default {
  id: "team-entry",
  title: "Sign up to TeamStats",
  subtitles: [
    "Manage, analyse and organise your team and players. Professional features for all football teams."
  ],
  imageUrl:
    "https://assets.teamstats.net/img-m-600-70/backgrounds/football-background-2.jpg",
  component: TeamEntry
};
